import { createAction, props } from '@ngrx/store';
import {
  IBusinessPaymentRunDetailEmployees,
  IUpdateEmployeeSalaryRequest,
  IUpdateEmployerMonthlyContributionsRequest
} from '../dto/business-payment-run-detail-employees.dto';
import { IFilterPaymentRunsRequest } from '../models/filter.model';

export const loadBusinessPaymentRunDetailEmployees = createAction(
  '[BusinessPaymentRunDetailEmployee] Load BusinessPaymentRunDetailEmployees',
  props<{ businessId: string; businessPaymentRunId: string; request: IFilterPaymentRunsRequest }>()
);

export const loadBusinessPaymentRunDetailEmployeesSuccess = createAction(
  '[BusinessPaymentRunDetailEmployee] Load BusinessPaymentRunDetailEmployees Success',
  props<{ response: IBusinessPaymentRunDetailEmployees[] }>()
);

export const loadBusinessPaymentRunDetailEmployeesFailure = createAction(
  '[BusinessPaymentRunDetailEmployee] Load BusinessPaymentRunDetailEmployees Failure',
  props<{ error: Error | any }>()
);

// Update Employee Salary
export const updateEmployeeSalaryRequest = createAction(
  '[UpdateEmployeeSalary] Update Employee Salary Request',
  props<{ businessId: string; businessUserProfileId: string; businessPaymentRunId: string; request: IUpdateEmployeeSalaryRequest }>()
);

export const updateEmployeeSalarySuccess = createAction(
  '[UpdateEmployeeSalary] Update Employee Salary Success',
  props<{ response: string }>()
);

export const updateEmployeeSalaryFailure = createAction(
  '[UpdateEmployeeSalary] Update Employee Salary Failure',
  props<{ error: Error | any }>()
);

// Update Employer Monthly Contributions (Amount & Percentage)
export const updateEmployerMonthlyContributionsRequest = createAction(
  '[UpdateEmployerMonthlyContributions] Update Employer Monthly Contributions Request',
  props<{
    businessId: string;
    businessUserProfileId: string;
    businessPaymentRunId: string;
    request: IUpdateEmployerMonthlyContributionsRequest;
  }>()
);

export const updateEmployerMonthlyContributionsSuccess = createAction(
  '[UpdateEmployerMonthlyContributions] Update Employer Monthly Contributions Success',
  props<{ response: string }>()
);

export const updateEmployerMonthlyContributionsFailure = createAction(
  '[UpdateEmployerMonthlyContributions] Update Employer Monthly Contributions Failure',
  props<{ error: Error | any }>()
);

export const loadBusinessPaymentRunDetailEmployeesByProduct = createAction(
  '[BusinessPaymentRunDetailEmployee] Load BusinessPaymentRunDetailEmployeesByProduct',
  props<{ businessId: string; businessPaymentRunId: string; productId: string; request: IFilterPaymentRunsRequest }>()
);

export const loadBusinessPaymentRunDetailEmployeesByProductSuccess = createAction(
  '[BusinessPaymentRunDetailEmployee] Load BusinessPaymentRunDetailEmployeesByProduct Success',
  props<{ response: IBusinessPaymentRunDetailEmployees[] }>()
);

export const loadBusinessPaymentRunDetailEmployeesByProductFailure = createAction(
  '[BusinessPaymentRunDetailEmployee] Load BusinessPaymentRunDetailEmployeesByProduct Failure',
  props<{ error: Error | any }>()
);
